export default "__VITE_ASSET__CnrLX1J1__"